import type { Prefill } from '@/features/procurement/poImport';

/**
 * How a field looks after an order-PDF import:
 *  - `required` — a field the PO needs that is still empty or invalid.
 *  - `check`    — has a value (or a default), but the read was unsure or
 *                 the value didn't match Atlas records; worth a look.
 *  - `prefill`  — read off the document.
 */
export type ReviewTone = 'required' | 'check' | 'prefill';

export interface ReviewIssue {
  /** DOM id of the control to focus when the issue is clicked. */
  targetId: string;
  label: string;
  tone: 'required' | 'check';
  hint?: string;
}

/** Input / select-trigger classes for a field's review tone. */
export function reviewFieldClass(tone: ReviewTone | null | undefined): string {
  switch (tone) {
    case 'required':
      return 'border-fresh-salmon-dark bg-fresh-salmon/10 ring-1 ring-fresh-salmon-dark/40';
    case 'check':
      return 'border-fresh-salmon bg-atmosphere/15 dark:bg-atmosphere/10';
    case 'prefill':
      return 'border-atmosphere-dark/50 bg-atmosphere/20 dark:border-atmosphere/50 dark:bg-atmosphere/10';
    default:
      return '';
  }
}

/** Tone for a field given its prefill record and live review state. */
export function toneFor(
  prefill: Prefill | undefined,
  issue: 'required' | 'check' | null | undefined,
): ReviewTone | null {
  if (issue) return issue;
  if (!prefill) return null;
  return prefill.confidence === 'low' ? 'check' : 'prefill';
}
